<template>
  <div
    :id="popoverTarget"
    class="position-relative overflow-visible"
  >
    <a
      v-if="item.isFolder"
      :class="`file-icon ${hover ? 'text-primary' : 'text-main'}`"
      @click="open"
      @mouseover="hover = true"
      @mouseleave="handleLeave"
    >
      <GjIcon
        name="Folder"
      />
    </a>
    <a
      v-else
      :class="`file-icon ${hover ? 'text-primary' : 'text-main'}`"
      @click="open"
      @mouseover="hover = true"
      @mouseleave="handleLeave"
    >
      <GjIcon
        name="File"
        @click="open"
      />
    </a>
    <b-popover
      :show.sync="hover"
      :target="popoverTarget"
      boundary-padding="0"
      custom-class="p-0 file-hover"
      offset="-10"
    >
      <div
        @mouseover="handlePopoverOver"
        @mouseleave="hover=false"
      >
        <directory-field-hover
          :item-key="item.key"
          :error="errorFetching"
          :item="fetchedData"
          :fetching="fetchingData"
          :hovered="hover"
        />
      </div>
    </b-popover>
  </div>
</template>

<script>
import DirectoryFieldHover from './DirectoryFieldHover.vue'

export default {
  name: 'DirectoryIcon',
  components: {
    DirectoryFieldHover,
  },
  props: {
    toRefetch: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      hiding: false,
      hover: false,
      initializedFetch: false,
      fetchedData: null,
      fetchingData: false,
      errorFetching: false,
    }
  },
  computed: {
    popoverTarget() { return `directory-field-icon-${this.item.key}` },
    hoverElementId() { return `hover-element-${this.item.key}` },
    bucketName() { return this.$route.params.id },
  },
  watch: {
    hover(val) {
      if (val && !this.initialized) {
        this.initializedFetch = true
      }
      if (val && this.toRefetch.includes(this.item.key)) {
        this.setData()
        this.$emit('removeToRefetch', this.item.key)
      }
    },
    initializedFetch(val) {
      if (val) {
        this.setData()
      }
    },
  },
  methods: {
    handlePopoverOver() {
      if (this.hiding) {
        this.hiding = false
        this.hover = true
      }
    },
    handleLeave() {
      if (this.hover && !this.hiding) {
        this.hiding = true
        setTimeout(() => {
          if (this.hiding) {
            this.hover = false
            this.hiding = false
          }
        }, 500)
      }
    },
    open() {
      this.$emit('open')
    },
    setData() {
      if (!this.item.isFolder) {
        this.fetchingData = true
        const query = {
          accountId: this.$route.params.accountId,
          ...this.item,
          bucketName: this.bucketName,
        }

        this.$store.dispatch('accountObjects/fetchObjectInfo', query).then(res => {
          this.errorFetching = false
          this.fetchedData = res.data.result
          this.fetchingData = false
        }).catch(() => {
          this.fetchingData = false
          this.fetchedData = null
          this.errorFetching = true
          setTimeout(() => {
            this.initializedFetch = false
          }, 5000)
        })
      } else {
        this.fetchedData = this.item
        this.fetchingData = false
      }
    },
  },
}
</script>
